import { render, staticRenderFns } from "./step3.vue?vue&type=template&id=09140a96&scoped=true"
import script from "./step3.vue?vue&type=script&lang=js"
export * from "./step3.vue?vue&type=script&lang=js"
import style0 from "./step3.vue?vue&type=style&index=0&id=09140a96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09140a96",
  null
  
)

export default component.exports